<template>
    <section class="main">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-profile"></i>实名相关</el-breadcrumb-item>
                <el-breadcrumb-item>实名制测试</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <el-table :data="table.tableData" v-loading="table.loading" :cell-style="{ textAlign: 'center' }"
                :header-cell-style="{ textAlign: 'center' }" :default-sort="{ prop: 'createTime', order: 'descending' }">
                <el-table-column label="ID" prop="antiaddictionId"></el-table-column>
                <el-table-column label="realName" prop="realName" width="75px"></el-table-column>
                <el-table-column label="cardNo" prop="cardNo"></el-table-column>
                <el-table-column label="status" prop="status" width="70px"></el-table-column>
                <el-table-column label="CreateTime" prop="createTime" :formatter="dateFormat" sortable></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="table.pageIndex"
                    :page-size="table.pageSize" :total="table.pageTotal" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
    </section>  
</template>
 
<script>
import moment from 'moment'
import { getAntiAddictionPage } from '../../api/antiaddiction.js'
export default { 
    name: 'AntiaddictionTest',
    data() {
        return {
            // 表单数据
            table: {
                tableData: [],
                pageIndex: 1,   // 页码
                pageTotal: 0,   // 总数据量
                pageSize: 0,    // 单页数据量
                loading: false, // 加载动画
            }
        }
    },
    created() {
        this.getAntiProjectData()
    },
    activated() {
        this.getAntiProjectData()
    },
    methods: {
        // 获取表单数据
        getAntiProjectData() {
            this.table.loading = true
            // 参数
            let params = { 'pageNum': this.table.pageIndex }
            // 发送请求
            getAntiAddictionPage(params).then(res => {
                if (res.data.code == 200) {
                    this.table.tableData = res.data.data.records
                    this.table.pageTotal = res.data.data.total
                    this.table.pageSize = res.data.data.size
                } else {
                    this.$message.error(res.data.message)
                }
                this.table.loading = false
            }).catch(err => {
                this.table.loading = false
            })
        },

        // 分页导航
        handlePageChange(val) {
            this.table.pageIndex = val
            this.getAntiProjectData()
        },

        //el-Tbale 显示时间格式
        dateFormat(row, column) {
            let date = row[column.property]
            if (date == undefined) return ''
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
    }
}
</script>

<style scoped></style>
